import { numberToLettersEN } from "./numbersToLetters";

type Args = {
  andWord?: boolean; 
};

export const functionRegistry: Record<string, (value: unknown, args?: any) => string> = {
  "util.numberToLetters": (value: unknown, args: Args = {}) => numberToLettersEN(value, { andWord: !!args.andWord }),
};
